import * as helper from './common-helper';

const isKoubei = helper.getUrlParam('isKoubei'); // 是否是口碑秒付
const kShopId = helper.getUrlParam('kShopId'); // 口碑秒付ShopId
const commodityId = helper.getUrlParam('commodityId'); // 口碑秒付commodityId
const appId = helper.getUrlParam('appId'); // 口碑秒付appId

exports.getSecondsToPayParams = () => {
  return {
    isKoubei: isKoubei === 'true',
    appId,
    shopId: kShopId,
    commodityId,
  };
};

exports.secondsToPayBurryStart = (obj) => { // 此处进行埋点BEGIN
  document.addEventListener('AlipayJSBridgeReady', () => {
    const req = {
      appId,
      shopId: kShopId,
      commodityId,
    };
    if (window.MCloudJSBridge) {
      window.MCloudJSBridge.processStartLog(Object.assign({}, req, obj));
    }
  });
};

exports.secondsToPayBurryEnd = (obj) => { // 此处进行埋点END
  const req = {
    appId,
    shopId: kShopId,
    endStatus: 'Success',
    commodityId,
  };
  if (window.MCloudJSBridge) {
    window.MCloudJSBridge.processEndLog(Object.assign({}, req, obj));
  }
};

exports.secondsToPayIncludeScript = (callback, obj) => {
  const scriptEle = document.createElement('script');
  scriptEle.type = 'text/javascript';
  scriptEle.src = 'https://os.alipayobjects.com/rmsportal/oknmeDPmBzRhliY.js';
  const x = document.getElementsByTagName('head')[0];
  x.insertBefore(scriptEle, x.firstChild);

  scriptEle.onload = () => { // 此处进行埋点BEGIN
    callback(obj);
  };
};




// WEBPACK FOOTER //
// ./src/helper/seconds-to-pay.js